import { configureStore } from "@reduxjs/toolkit";

import {bidibReducer, planReducer, rootReducer} from './reducers'

export default configureStore({
    reducer: {
        bidib: bidibReducer,
        plan: planReducer,
        root: rootReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
    }),
})